module.exports = __webpack_public_path__ + "img/social-icon-discord.dffd1870.svg";